export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '《蜜桃成熟时》是哪一年上映的？',
    a: '影片于 1993 年 4 月 17 日在香港上映，由张肇麟执导、高志森监制，高志森影业有限公司出品。',
  },
  {
    q: '这部电影的主演是谁？',
    a: '女主角阿珍（Jane）由李丽珍出演；其余主要演员包括潘震伟（饰 John）、霍瑞华（饰 David），以及黄光亮、成奎安、左颂昇、邵传勇、焦姣、田青、潘雁英、余慕莲等。',
  },
  {
    q: '这部片子有续集吗？',
    a: '有后续作品。1997 年的《蜜桃成熟时 1997》被视为系列延续，2011 年又有加入科幻元素的《蜜桃成熟时 33D》。需要说明的是，续作多为在题材与命名上的延续，故事与第一部并不完全连贯。',
  },
  {
    q: '影片属于什么类型和分级？',
    a: '影片属剧情 / 爱情类型，语言为粤语，在香港被列为第三级（Ⅲ 级）影片，含有成人内容。',
  },
  {
    q: '可以在哪里观看？',
    a: '本页不提供任何播放地址，仅作观影前的资料与导览参考。建议通过正规、合法的影视平台或发行方渠道了解观看方式。',
  },
  {
    q: '影片适合什么观众？',
    a: '由于影片含成人内容且被列为第三级，仅适合成年观众。请在了解分级与内容性质后，再判断是否适合自己观看。',
  },
];